const INITIAL_STATE = {
    fretes: [],
    frete: {},
    loading: false,
    processing: false
}

export default function FreteReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'FRETES_FETCHED':
            return { ...state, fretes: action.payload }
        case 'FRETES_LOADING':
            return { ...state, loading: action.payload }
        case 'FRETES_PROCESSING':
            return { ...state, processing: action.payload }
        default:
            return state
    }
}
